import React from 'react'

export default function Image({ data, index }) {
    return (
        <div className="post__image" id={`novedad-detalle-image-${index}`}>
            <img src={data.primary.image_post.url} alt={data.primary.image_post.alt} />
        </div>
    )
}